import React, { useState, useId } from "react";
import { ChevronDown } from "lucide-react";

const FAQ = ({ faq }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentId = useId();

  return (
    <div
      className={`rounded-2xl overflow-hidden border transition-all duration-500 ${
        isOpen
          ? "bg-[#e8f7fd] border-[#84d4f2] shadow-md"
          : "bg-gradient-to-br from-white to-[#f7fbfe] border-gray-200 hover:shadow-md"
      }`}
    >
      {/* Header */}
      <button
        type="button"
        aria-expanded={isOpen}
        aria-controls={contentId}
        onClick={() => setIsOpen((prev) => !prev)}
        className="w-full flex items-center justify-between px-4 sm:px-6 md:px-8 py-4 sm:py-5 md:py-6 text-left focus:outline-none"
      >
        <span className="font-semibold text-sm sm:text-base md:text-lg leading-snug text-[#2a3136] pr-4">
          {faq.question}
        </span>

        <ChevronDown
          className={`w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 text-[#1a81ba] transition-transform duration-300 ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
        />
      </button>

      {/* Answer */}
      <div
        id={contentId}
        className={`overflow-hidden transition-[max-height,opacity] duration-500 ease-in-out ${
          isOpen ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
       <div className="px-4 sm:px-6 md:px-8 pb-4 sm:pb-5 md:pb-6 text-[#2a3136] text-sm sm:text-[15px] md:text-base leading-relaxed bg-gradient-to-br from-[#f4fbff] to-[#e8f7fd] border-t border-[#84d4f2]/40 text-justify">
          {faq.answer}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
